import { Injectable, PipeTransform, QueryList, ViewChildren } from '@angular/core';

import { BehaviorSubject, Observable, of, Subject } from 'rxjs';

import { DecimalPipe } from '@angular/common';
import { debounceTime, delay, switchMap, tap } from 'rxjs/operators';
import { NgbdSortableHeader, SortDirection, SortEvent } from './../directives/sortable.directive';
import * as XLSX from 'xlsx';
// import { ClipboardService } from 'ngx-clipboard';
// import jsPDF from 'jspdf';
// import jsPDF from 'jspdf';
import { jsPDF } from "jspdf";

interface SearchResult {
  dataSoruces: any[];
  total: number;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: string;
  sortDirection: SortDirection;
}

function compare(v1, v2) {
  return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

function sort(dataSoruces: any[], column: string, direction: string): any[] {
  if (direction === '') {
    return dataSoruces;
  } else {
    return [...dataSoruces].sort((a, b) => {
      const res = compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
}

function matches(dataSoruce: any, term: string, pipe: PipeTransform) {
  // return dataSoruce.Title.toLowerCase().includes(term);
  // || pipe.transform(dataSoruce.area).includes(term)
  // || pipe.transform(dataSoruce.population).includes(term);

  return eval(Object.getOwnPropertyNames(dataSoruce).filter(e => dataSoruce[e] != null).map(e => typeof (dataSoruce[e]) === 'string' ?
    `dataSoruce['${e}'].toLowerCase().includes((term || '').toLowerCase())` :
    (typeof (dataSoruce[e]) === 'number' ? `pipe.transform(dataSoruce['${e}']).includes(term)` : `dataSoruce['${e}'].toString().includes(term)`)).join(' || '));

}


@Injectable()
export class DttableService {
  dataSoruces = [];
  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private _dataSoruces$ = new BehaviorSubject<any[]>([]);
  private _total$ = new BehaviorSubject<number>(0);

  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };

  // @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(private pipe: DecimalPipe
    // , private _clipboardService: ClipboardService
  ) {
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      debounceTime(200),
      switchMap(() => this._search()),
      delay(200),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      this._dataSoruces$.next(result.dataSoruces);
      this._total$.next(result.total);
    });

    this._search$.next();
  }

  get dataSoruces$() { return this._dataSoruces$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }

  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchResult> {
    const { sortColumn, sortDirection, pageSize, page, searchTerm } = this._state;

    // 1. sort
    let dataSoruces = sort(this.dataSoruces, sortColumn, sortDirection);

    // 2. filter
    dataSoruces = dataSoruces.filter(dataSoruce => matches(dataSoruce, searchTerm, this.pipe));
    const total = dataSoruces.length;

    // 3. paginate
    dataSoruces = dataSoruces.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    return of({ dataSoruces, total });
  }

  getDataSource(dataSource) {
    this.dataSoruces = dataSource;
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      debounceTime(200),
      switchMap(() => this._search()),
      delay(200),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      this._dataSoruces$.next(result.dataSoruces);
      this._total$.next(result.total);
    });

    this._search$.next();
  }



  onSort({ column, direction }: SortEvent, header) {
    // resetting other headers
    direction = (direction == '' ? (this._state.sortDirection == 'asc' ? 'desc' : 'asc') : direction);
    header.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.sortColumn = column;
    this.sortDirection = direction;
  }

  export(type, list, tableid = '', filename = document.getElementsByTagName('title')[0].text, divId = '') {
    if (divId == '') {
      let div = document.getElementById('dttableexportdiv');
      if (div == undefined || div == null) {
        div = document.createElement('div') as HTMLDivElement;
      }
      let cols = [];
      let title = [];
      if (tableid != '') {
        const a = Array.from(document.getElementById(tableid).children[0].children[0].children);
        const b = a.filter(e => Array.from(e.attributes).filter(a => a.name === 'data-item').length > 0).map(b => Array.from(b.attributes).filter(e => e.name === 'data-item').map(e => e.value));
        b.map(e => cols = cols.concat(e));
        title = a.filter(e => Array.from(e.attributes).filter(a => a.name === 'data-item').length > 0).map(b => Array.from(b.attributes).filter(e => e.name === 'data-value').length > 0 ? Array.from(b.attributes).filter(e => e.name === 'data-value').map(e => e.value) : b.innerHTML);
        let table = `<table id="selectedele" class="table table-border selectedele"><tr id="titletr"><td  colspan="${cols.length}" style="text-align: center;"><b>${filename}</b></td></tr><thead><tr>${cols.map((e, i) => '<th><b>' + title[i] + '</b></th>').join('')}</tr></thead><tbody>${list.map(e => '<tr>' + cols.map(a => '<td>' + (e[a] == null ? '' : e[a]) + '</td>').join('') + '</tr>').join('')}</tbody></table>`

        div.id = 'dttableexportdiv';

        div.innerHTML = table;
        div.style.zIndex = '-1';
      }
      if (document.getElementById('dttableexportdiv') == undefined || document.getElementById('dttableexportdiv') == null) {
        document.body.appendChild(div);
      }

      switch (type) {
        case 'excel':
          this.exportToExcel((tableid == '' ? list : div), tableid !== '', 'xlsx', filename.replace(' ', ''));
          break;
        case 'csv':
          this.exportToExcel((tableid == '' ? list : div), tableid !== '', 'csv', filename.replace(' ', ''));
          break;
        case 'pdf':
          const doc = new jsPDF('l', 'mm', 'a4', true);
          const tl = title.length > 0 ? title.map(e => e) : cols;

          doc.table(0, 0, list.map(a => JSON.parse(('{' + cols.map((e, i) => (`"${tl[i]}":"${(a[e] == null || a[e] == '') ? ' ' : ((a[e].toString()).replace(/"/g, '\\\"'))}"`)).join() + '}'))), tl, { autoSize: true })
          doc.save(filename + ".pdf");
          // const elementToPrint = document.getElementById('dttableexportdiv'); //The html element to become a pdf
          // const pdf = new jsPDF('l', 'pt', 'a4');
          // pdf.html(elementToPrint, { callback: () => { debugger; } });
          // pdf.save(filename + ".pdf");
          break;
        case 'copy':
          const h2 = document.createElement('H2');
          h2.innerText = filename;
          document.getElementById('dttableexportdiv').prepend(h2);
          document.getElementById('titletr').remove();
          let range = document.createRange();
          range.selectNodeContents(document.getElementById('dttableexportdiv'))
          let select = window.getSelection()
          select.removeAllRanges()
          select.addRange(range)
          document.execCommand('copy');

          var divpoup = document.createElement('div');
          divpoup.id = "divpoup";
          divpoup.innerHTML = `<h2>Copy to clipboard</h2><div>Copied ${list.length} rows to clipboard</div>`;

          document.body.appendChild(divpoup);
          setTimeout(function () {
            document.getElementById('divpoup').remove();
          }, 2000);


          break;
        case 'print':
          // const divToPrint = document.getElementById("selectedele");
          // const newWin = window.open("");
          // newWin.document.write(divToPrint.outerHTML);
          // newWin.print();
          // newWin.close();

          let printContents, popupWin;
          printContents = document.getElementById('selectedele').outerHTML;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
          popupWin.document.open();
          popupWin.document.write(`
      <html>
        <head>
          <title>${filename}</title>
          
          <style>
          #titletr{
            display:none;
          }
          table#selectedele {
            width: 100% !important;
            color: #342E49;
            margin-bottom: 1.5rem;
            border-collapse: collapse;
        }
        
        .table td {            
            vertical-align: inherit !important;
        }
        
        .table th, .table td {
            vertical-align: top;
            border-top: 1px solid #E0E0E0;
            white-space: pre-line;
        }
        
        .table thead th {
            vertical-align: bottom;
            border-bottom: 2px solid #E0E0E0;
        }
        
        .table thead th {
            vertical-align: bottom;
            border-bottom: 2px solid #E0E0E0;
        }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
          );
          popupWin.document.close();

          break;
      }
      if (document.getElementById('dttableexportdiv') != undefined) {
        document.getElementById('dttableexportdiv').remove();
      }
    } else {
      switch (type) {
        case 'excel':
          this.exportDivToExcel(divId, filename);
          break;
        case 'print':
          const divToPrint = document.getElementById(divId);
          const newWin = window.open("");
          newWin.document.write(divToPrint.outerHTML);
          newWin.print();
          newWin.close();
          break;
      }
    }
  }

  exportToExcel(list, istable, type, filename) {

    const ws: XLSX.WorkSheet = istable ? XLSX.utils.table_to_sheet(list) : XLSX.utils.json_to_sheet(list);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `${filename}.${type}`);
    // XLSX.writeFile(wb, 'test.csv');
    // XLSX.writeFile(wb, 'test.pdf');

  }

  exportDivToExcel(id, filename, ishtml = false) {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><div>{table}</div></body></html>'
    const base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) };
    const format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };
    const table = ishtml ? id : document.getElementById(id);
    const ctx = ishtml ? { worksheet: filename || 'Worksheet', table: table } : { worksheet: filename || 'Worksheet', table: table };
    window.location.href = uri + base64(format(template, ctx))



    // var tableToExcel = (function () {
    //   var uri = 'data:application/vnd.ms-excel;base64,'
    //     , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><div>{table}</div></body></html>'
    //     , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
    //     , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    //   return function (table, name) {
    //     if (!table.nodeType) table = document.getElementById(table)
    //     var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
    //     window.location.href = uri + base64(format(template, ctx))
    //   }
    // })()
  }
}
